import React from 'react';
import * as lib from '~/dependencies';
import { BoxTabs, ItemTab } from './styles';

export default function TabContacts({ setTab, tab, isAdmin }) {
  const { t, i18n } = lib.useTranslation();

  return (
    <BoxTabs>
      <ItemTab
        lang={i18n.language}
        className={tab === 0 && 'active'}
        onClick={() => setTab(0)}>
        <span>{t('screens.contacts.components.tab.private')}</span>
      </ItemTab>
      {isAdmin && (
        <ItemTab
          lang={i18n.language}
          className={tab === 1 && 'active'}
          onClick={() => setTab(1)}>
          <span>{t('screens.contacts.components.tab.shared')}</span>
        </ItemTab>
      )}
    </BoxTabs>
  );
}

TabContacts.defaultProps = {
  tab: 0,
  setTab: () => {},
  isAdmin: false,
};

TabContacts.propTypes = {
  tab: lib.PropTypes.number,
  setTab: lib.PropTypes.func,
  isAdmin: lib.PropTypes.bool,
};
